import { css } from '@emotion/react';
import { Headers } from '@frontend/header';
import { useTranslation } from '@frontend/i18n';
import { Page } from '@frontend/page';
import { theme } from '@frontend/theme';
import { Tabs } from '@frontend/design-system';
import { AnalyticsView } from '../components/call-queue-stats/analytics-view';
import { CardView } from '../components/call-queue-stats/card-view';

export const CallQueueStats = () => {
  const { t } = useTranslation('call-queue-stats');

  return (
    <Tabs initialTab='cards-tab'>
      <Page>
        <Headers.Root
          css={css`
            padding: 0;
          `}
        >
          <Headers.RouterBreadcrumb />
          <Headers.TitleRow>
            <Headers.Title>
              <Headers.RouterHeader title={t('Call Queue Data')} />
            </Headers.Title>
          </Headers.TitleRow>
          <Headers.Tabs>
            <Tabs.Bar css={{ marginBottom: theme.spacing(3) }}>
              <Tabs.Tab
                id='cards-tab'
                onClick={() => {}}
                css={css`
                  color: ${theme.colors.primary};
                `}
              >
                {t('Call Queues')}
              </Tabs.Tab>
              <Tabs.Tab
                id='charts-tab'
                onClick={() => {}}
                css={css`
                  color: ${theme.colors.primary};
                `}
              >
                {t('Analytics')}
              </Tabs.Tab>
              {/* <Tabs.Tab
                id='access-tab'
                controls='access-panel'
                onClick={() => {}}
                css={css`
                  color: ${theme.colors.primary};
                `}
              >
                {t('Call Queue Access')}
              </Tabs.Tab> */}
            </Tabs.Bar>

            {/* <Tabs.Panel id='access-panel' controller='access-tab'>
              <CardView />
            </Tabs.Panel> */}
          </Headers.Tabs>
        </Headers.Root>
        <Page.Body>
          <Tabs.Panel controller='cards-tab'>
            <CardView />
          </Tabs.Panel>
          <Tabs.Panel controller='charts-tab' keepMounted={false}>
            <AnalyticsView />
          </Tabs.Panel>
        </Page.Body>
      </Page>
    </Tabs>
  );
};
